import { createFileRoute } from "@tanstack/react-router";
import { PartRecord } from "@/components/companion/PartRecord";

export const Route = createFileRoute("/parts/$partNumber")({
  component: PartDetail,
});

function PartDetail() {
  const { partNumber } = Route.useParams();
  return <PartRecord partNumber={partNumber} />;
}
